/*
function notifyAddCart($i){
  $('.loading').hide();
  $.jGrowl($i,{
    life: 3000
  });
}
*/

function notifyAddCartFail($i){
  $('.loading').hide();
  $.jGrowl($i,{
    life: 3000,
    position:'center'
  });	
}

var iceActiveAddButton = null;
var iceCartButtonTimer = null;

function iceSetCartButtonLoading($button){
  if (!$button || !$button.length) return;
  var button = $button[0];
  if (!button.getAttribute('data-ice-original-label')) {
    button.setAttribute('data-ice-original-label', $.trim($button.text()) || 'Add To Cart');
  }
  if (iceCartButtonTimer) window.clearTimeout(iceCartButtonTimer);
  iceActiveAddButton = $button;
  $button
    .attr({'aria-busy':'true','aria-live':'polite'})
    .removeClass('ice-cart-added ice-cart-error')
    .addClass('ice-cart-loading')
    .text('Adding…');
}

function iceFinishCartButton(success){
  if (!iceActiveAddButton || !iceActiveAddButton.length) return;
  var $button = iceActiveAddButton;
  var original = $button.attr('data-ice-original-label') || 'Add To Cart';
  iceActiveAddButton = null;
  $button
    .attr('aria-busy','false')
    .removeClass('ice-cart-loading')
    .addClass(success ? 'ice-cart-added' : 'ice-cart-error')
    .text(success ? 'Added ✓' : 'Please try again');
  iceCartButtonTimer = window.setTimeout(function(){
    $button.removeClass('ice-cart-added ice-cart-error').text(original);
  }, success ? 1800 : 2500);
}

/* Ajax Add To Cart */

function addToCart(e){
  if (typeof e !== 'undefined') e.preventDefault();

  /* Show loading */
  $('.loading').show();

  var $this = $(this);

  iceSetCartButtonLoading($this);
  $this.addClass('disabled');

  var form = $this.parents('form');

  // Hide Modal
  $('.modal').hide();

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: true,
    data: form.serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: addToCartSuccess,
    cache: false
  });
  
}

function addToCartSuccess (jqXHR, textStatus, errorThrown){
  iceFinishCartButton(true);
  $('.add-to-cart').removeClass('disabled');
  $('.loading').hide();
  $('#layer-addcart-modal').show();

  var price = jqXHR['price'];
  var qty = jqXHR['quantity'];
  var total = price * qty;
  var addcart_modal_image = '<img src="'+ Shopify.resizeImage(jqXHR['image'], 'small') +'" alt="'+ jqXHR['title'] +'"/>';
  var addcart_modal_name = jqXHR['product_title'];
  var addcart_modal_variant = ""; if(jqXHR['variant_title'] != null) addcart_modal_variant = 'Variant: '+jqXHR['variant_title'];
  var addcart_modal_qty = '<strong>Quantity:</strong>'+jqXHR['quantity'];
  var addcart_modal_price = '<strong>Total:</strong><span class="money">'+Shopify.formatMoney(total, "")+'</span>';
  
  $('.addcart-modal-image').html(addcart_modal_image);
  $('.addcart-modal-title').html(addcart_modal_name);
  $('.addcart-modal-price').html(addcart_modal_price);
  $('.addcart-modal-variant').html(addcart_modal_variant); 
  $('.addcart-modal-qty').html(addcart_modal_qty);
  $('.addcart-modal-box').show();

  /* Phase 2: one asynchronous cart read updates both the header cart and modal count. */
  Shopify.getCart(function(cart) {
    Shopify.updateCartInfo(cart, '#cart-info #cart-content');
    var itemCount = parseInt(cart.item_count, 10) || 0;
    $('.addcart-modal-number').html(itemCount === 1 ? 'There is 1 item in your cart.' : 'There are '+itemCount+' items in your cart.');

    /* Phase 18: populate the modal's ex-GST, GST and inc-GST summary. */
    if (window.ICECartTransparency && typeof window.ICECartTransparency.render === 'function') {
      window.ICECartTransparency.render(cart);

    }
  });
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  iceFinishCartButton(false);
  $('.add-to-cart').removeClass('disabled');
  var response = $.parseJSON(jqXHR.responseText);

  var $i = '<div class="error">'+ response.description +'</div>';
  notifyAddCartFail($i);
}

function addcartModalHide(){
  $("#layer-addcart-modal").addClass("zoomOut animated").fadeOut();
  $("#layer-addcart-modal").removeClass("zoomOut animated");
}

(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

var g = {

      common : {
        init: function(){
          $("body").on( 'click','.add-to-cart', addToCart );
        }
      }
  
      ,templateIndex : {
        init: function(){}
      }

      ,templateProduct : {
        init: function(){}
      }

      ,templateCart : {
        init: function(){}
      }
	}  
    ,u = {
        fire: function(t, a, o) {
            var e = g;
            a = void 0 === a ? "init" : a, "" !== t && e[t] && "function" == typeof e[t][a] && e[t][a](o)
        }
        ,loadEvents: function() {
            var t = document.body.id;
            u.fire("common"), $.each(document.body.className.split(/\s+/), function(a, o) {
                u.fire(o), u.fire(o, t)
            })
        }
    };

$(document).ready(u.loadEvents);